import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .course-progress-bar {
    margin-top: 8px;
    flex-grow: 1;
    height: 18px;
    border-radius: 4px;
    background-color: var(--default-gray);

    .progress {
      border-radius: 4px;
      background-color: var(--progress-bar-background);
      height: 100%;
    }
  }
`;

export { ProgressBarContainer };
